import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import Spinner from "../../BaseComponents/BaseLoader";

const LoadingContext = createContext({ setLoading: () => {} });

/* Memoised children wrapper — only re-renders when children prop itself changes,
   NOT when loading state changes. This prevents the entire app from re-rendering
   every time a loader is shown/hidden. */
const StableChildren = React.memo(function StableChildren({ children }) { return children; });

export const LoadingProvider = ({ children }) => {
  const [loading, setLoadingState] = useState(false);

  const setLoading = useCallback((v) => setLoadingState(v), []);

  const ctx = useMemo(() => ({ setLoading }), [setLoading]);

  return (
    <LoadingContext.Provider value={ctx}>
      <StableChildren>{children}</StableChildren>
      {/* Render spinner in a portal so it never causes children to re-render */}
      {loading && ReactDOM.createPortal(<Spinner />, document.body)}
    </LoadingContext.Provider>
  );
};

export const usePageLoader = () => {
  const ctx = useContext(LoadingContext);
  if (!ctx) throw new Error("usePageLoader must be used inside LoadingProvider");
  return ctx;
};

export default LoadingContext;
